var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":"","justify-space-around":"","align-content-space-around":""}},[_c('v-flex',[_c('img',{staticClass:"robot",attrs:{"src":require("@/assets/robot.svg")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }